import { render, staticRenderFns } from "./ProductUnitSidebar.vue?vue&type=template&id=777c910b&"
import script from "./ProductUnitSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductUnitSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777c910b')) {
      api.createRecord('777c910b', component.options)
    } else {
      api.reload('777c910b', component.options)
    }
    module.hot.accept("./ProductUnitSidebar.vue?vue&type=template&id=777c910b&", function () {
      api.rerender('777c910b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-unit/ProductUnitSidebar.vue"
export default component.exports